<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>{{ title }} Topup</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">{{ title }} Topup</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card col-md-12">
          <form @submit.prevent="saveOrUpdate" method="POST" novalidate>
            <div class="card-header">
              <span>Topup Confirm</span>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group required">
                    <label class="control-label" for="mobile_no"
                      >Mobile No</label
                    >
                    <div class="input-group">
                      <!-- <span class="input-group-addon input-group-btn">
                                                       <i class="fas fa-pencil-alt"></i>
                                                </span> -->
                      <input
                        disabled
                        type="text"
                        class="form-control"
                        name="mobile_no"
                        id="mobile_no"
                        v-model="stateData.mobile_no"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label" for="amount">Amount</label>
                    <div class="input-group input-group">
                      <input
                        disabled
                        type="number"
                        min="0"
                        class="form-control"
                        name="amount"
                        id="amount"
                        v-model.number="stateData.amount"
                      />
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label" for="connection_type"
                      >Connection Type</label
                    >
                    <div class="input-group input-group">
                      <input
                        disabled
                        type="text"
                        class="form-control"
                        name="connection_type"
                        id="connection_type"
                        v-model="stateData.connection_type"
                      />
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label" for="service_charge"
                      >Service Charge</label
                    >
                    <div class="input-group input-group">
                      <input
                        disabled
                        type="number"
                        min="0"
                        class="form-control"
                        name="service_charge"
                        id="service_charge"
                        v-model.number="stateData.service_charge"
                      />
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label" for="payment_amount"
                      >Payment Amount</label
                    >
                    <div class="input-group input-group">
                      <input
                        disabled
                        type="number"
                        min="0"
                        class="form-control"
                        name="payment_amount"
                        id="payment_amount"
                        v-model.number="stateData.amount"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer row col-md-6 col-sm-6 col-lg-6">
              <div
                class="col-md-6 col-sm-6 col-lg-6 text-left"
                style="width: 50%"
              >
                <a class="btn btn-site" @click="$router.back()">Prev</a>
              </div>
              <div
                class="col-md-6 col-sm-6 col-lg-6 text-right"
                style="width: 50%"
              >
                <button class="btn btn-site" type="submit">Submit</button>
              </div>
            </div>
          </form>

          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
span.closed {
  /* background: green; */
  background: #caffd6;
  color: #119a30;
}
span.pending {
  background: #ffe9dd;
  /* color: #119A30; */
}
span.open {
  background: #ffe9dd;
}
span.in-progress {
  background: #ffe9dd;
}

div.input-group > button {
  background-color: #8d4097;
}

div.input-group > span {
  border: 1px solid #ccc !important;
}

div.input-group > span > i {
  padding: 10px;
}

hr {
  height: 2px;
  background: black;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: white !important;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";
import { Cordova } from "@awesome-cordova-plugins/core";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Capacitor } from "@capacitor/core";

export default {
  name: "TopupConfirm",
  metaInfo: {
    title: "TopupConfirm | Dotlines",
  },

  props: ["operator", "topup"],

  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    pid: null, // primary id of object to edit
    title: "",

    preloadOptions: {},

    stateData: {
      amount: 0,
      service_charge: 0,
      connection_type: "",
      id: "",
      mobile_no: "",
      username: "",
    },

    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },

    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),

  // method is called after page load
  mounted: function () {
    if (!this.operator || !this.topup) {
      this.$router.go(-1);
    }

    // console.log("State topup in store:", this.$store.state.topup)

    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    console.log("Topup:", this.topup);
    this.stateData = this.topup;

    console.log("Operator:", this.operator);
    if (this.operator == "GP") {
      this.title = "Grameenphone";
    } else if (this.operator == "BL") {
      this.title = "Banglalink";
    } else if (this.operator == "ROBI") {
      this.title = "Robi";
    } else if (this.operator == "AT") {
      this.title = "Airtel";
    } else if (this.operator == "TL") {
      this.title = "Teletalk";
    } else if (this.operator == "SK") {
      this.title = "Skitto";
    }

    this.pid = this.stateData.id;
  },

  methods: {
    saveOrUpdate() {
      var _this = this;
      let id = this.stateData.id;

      _this.$validator.validateAll().then((result) => {
        _this.stateData.status = 1;
        if (result) {
          let api_url;
          _this.is_loading = true;
          api_url = "/confirm_topup/" + id;

          axios({
            method: "PUT",
            url: api_url,
            data: _this.stateData,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              const responseData = response.data;
              console.log("Response Data::", responseData);
              _this.$toaster.success(responseData.message);
              _this.is_loading = false;

              if (_this.stateData.online === 1) {
                console.log(" Redirect URL:: ", redirectUrl);
                const paymentId = responseData.data.payment_id || 0;
                const redirectUrl =
                  responseData.data.redirect_url + "?payment_id=" + paymentId;

                if (!Capacitor.isNativePlatform()) {
                  alert("Redirect URL:: " + redirectUrl);
                  window.open(redirectUrl, "_self");
                } else {
                  console.log("gggggggggg::", redirectUrl);
                  // @ts-ignore
                  let ref = cordova.InAppBrowser.open(
                    redirectUrl,
                    "_blank",
                    "location=yes,hideurlbar=yes"
                  );
                  // let ref = cordova.InAppBrowser.open('https://google.com', '_blank', 'location=yes');
                  let myCallback = function (event) {
                    console.log("Updated URL: ", event.url);
                    // separate host form url
                    // let host = event.url.split('/')[2];

                    // get all query params
                    let queryParams = event.url.split("?")[1];

                    if (event.url.includes("topup_status?tnxStatus=")) {
                      console.log("InAppBrowser closed");
                      ref.close();
                      setTimeout(() => {
                        _this.$router.push("topup_status?" + queryParams);
                      }, 500);
                    }
                  };
                  ref.addEventListener("loadstart", myCallback);
                }
              } else {
                console.log("::offline payment::");
              }

              Object.keys(_this.stateData).forEach((key) => {
                _this.stateData[key] = null;
              }); // clear object property values
              //console.log("After Delete::",_this.ticket)
              _this.$router.push({ name: "topup" });
            })
            .catch((errors) => {
              //alert("Error happend!");
              //console.log(errors.response.data);
              _this.is_loading = false;
              _this.$setErrorsFromResponse(errors);
              //   _this.$setErrorsFromResponse(errors.response.data.errors);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
        }
      });
    },

    async loadOptionData() {
      let _this = this;
    },

    apiUsage(query = null) {},
  },
};
</script>
